import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import "../static/css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="dir">
        <div className="sec">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.3!2d76.9623!3d11.0167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDAxJzAwLjEiTiA3NsKwNTcnNDQuMyJF!5e0!3m2!1sen!2sin!4v1738829674000!5m2!1sen!2sin"></iframe>

          <h3>Main Office</h3>
          <p>
            SPP Insolvency Professionals LLP
            <br />
            2nd Floor, CODisSIA G.D. Naidu Towers,
            <br />
            Huzur Road, Coimbatore,
            <br />
            Tamil Nadu, India - 641018
          </p>
          <br />
          <p>
            +91 422 2319862 / 94888 1044
            <br />
            info@sppgroupa.com
          </p>
        </div>
        <div className="sec">
          <h3>Quick Links</h3>
          <div className="icons">
            <a href="/">
              <FaLinkedin />
            </a>
            <a href="/">
              {" "}
              <FaInstagram />
            </a>
            <a href="/">
              <FaTwitter />
            </a>
            <a href="/">
              <FaFacebook />
            </a>
          </div>
        </div>
        <div className="sec">
          <h3>Pages</h3>
          <ul>
            <li>
              <Link to="/">
                <span>Home</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/about">
                <span>About Us</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/team">
                <span>Our Team</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/services">
                <span>Services</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/cases">
                <span>Insolvency Cases</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/publications">
                <span>Our Publications</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/news">
                <span>What's New</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/knowledge">
                <span>Knowledge Bank</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/contact">
                <span>Contact Us</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="sec">
          <h3>Services</h3>
          <ul>
            <li>
              <Link to="/services?service=0">
                <span>Insolvency & Bankruptcy Service</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/services?service=1">
                <span>Audit & Assurance</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/services?service=2">
                <span>Corporate Stress & Turnaround</span>
              </Link>
            </li>
            <br />
            <li>
              <Link to="/services?service=3">
                <span>Financial Advisory</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div className="social">
        <div className="social-text">
          <div className="s_align">
            <Link to="/privacy-policy">privacy policy</Link>
          </div>
          <div className="s_align">
            <p>© 2024 SPP Insolvency Professionals LLP | IBBI Registration: IBBI/IPE/0143</p>
          </div>
          <div className="s_align">
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
